
export const Messages = {
    ORGANIZATION_NAME: 'BriqLabs',
    FOOTER_TEXT: '© 2024, Briqlabs. All rights reserved.',
    CONNECT_WITH_SPECIALIST:'Connect with a specialist', 
    GET_STARTED_FOR_FREE: 'Get started for free', 
    TRY_FOR_FREE: 'Try for Free',
    HOME:'Home',
    NO_SIGN_UP: 'No signup, no credit card required',
    CONTACT_US: 'Contact Us',
    NAME: 'Name',
    EMAIL: 'Email',
    MESSAGE: 'Message',
    SEND: 'Send',
    EMAIL_SUCCESS: 'Email sent successfully!'
}